import { FC } from "react";
import { AdvancedMarker, Map } from "@vis.gl/react-google-maps";
import { Employee } from "../../api/dto/Employee";
import { EmployeeAvatar } from "./EmployeeAvatar";
import { Project } from "../../api/dto/Project";
import { ProjectVisit } from "../../api/dto/ProjectVisit";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLocationDot, faPlay } from "@fortawesome/pro-solid-svg-icons";
import { getColor } from "../../api/dto/Color";

interface MapPosition {
  lat: number;
  lng: number;
}

interface MapWithMarkersProps {
  center: MapPosition;
  zoom: number;
  markers: MapPosition[];
}
export const MapWithMarkers: FC<MapWithMarkersProps> = (props) => {
  return (
    <Map
      defaultCenter={props.center}
      defaultZoom={props.zoom}
      mapId={"traas-live-map"}
    >
      {props.markers.map((marker, index) => {
        return <AdvancedMarker key={index} position={marker} />;
      })}
    </Map>
  );
};
interface EmployeeMapMarker {
  employee: Employee;
  pos: MapPosition;
  angle: number;
}
interface MapWithEmployeeMarkersProps {
  center: MapPosition;
  zoom: number;
  markers: EmployeeMapMarker[];
}
export const MapWithEmployeeMarkers: FC<MapWithEmployeeMarkersProps> = (
  props,
) => {
  return (
    <Map
      defaultCenter={props.center}
      defaultZoom={props.zoom}
      mapId={"traas-live-map"}
    >
      {props.markers.map((marker, index) => {
        return (
          <AdvancedMarker
            key={index}
            position={marker.pos}
            title={marker.employee.firstName}
          >
            <div className={"shadow-lg rounded-full relative"}>
              <div className={"-m-3 "}>
                <EmployeeAvatar employee={marker.employee} />
              </div>

              <div
                className="absolute left-1/2 top-1/2 pointer-events-none"
                style={{
                  transform: `translate(-50%, -50%) rotate(${marker.angle}deg)`,
                }}
              >
                <FontAwesomeIcon
                  icon={faPlay}
                  className="text-white text-sm -rotate-90 relative -top-7  block drop-shadow-[0_1px_2px_rgba(0,0,0,0.3)]"
                />
              </div>
            </div>
          </AdvancedMarker>
        );
      })}
    </Map>
  );
};

export interface ProjectVisitMapMarker {
  pos: MapPosition;
  projectVisit: ProjectVisit;
  color: string;
}
interface MapWithProjectVisitMarkersProps {
  center: MapPosition;
  zoom: number;
  markers: ProjectVisitMapMarker[];
}
export const MapWithProjectVisitMarkers: FC<MapWithProjectVisitMarkersProps> = (
  props,
) => {
  return (
    <Map
      defaultCenter={props.center}
      defaultZoom={props.zoom}
      mapId={"traas-live-map"}
    >
      {props.markers.map((marker, index) => {
        return (
          <AdvancedMarker
            key={index}
            position={marker.pos}
            title={marker.projectVisit.name}
          >
            <div
              className={`shadow-lg rounded-bl-full rounded-tl-full rounded-tr-full rotate-45 bg-white border ${getColor(marker.color).markerBorder} p-1`}
            >
              <FontAwesomeIcon
                icon={faLocationDot}
                className={`text-lg -rotate-45 mt-0.5 ${getColor(marker.color).marker}`}
              />
            </div>
          </AdvancedMarker>
        );
      })}
    </Map>
  );
};
